/** Homepage URL for "back" links (local nginx default). */
export const HOMEPAGE_URL = import.meta.env.VITE_HOMEPAGE_URL || 'https://6-tool.localhost';
